/**
 * Default tax rates used when no user-provided rates are available
 */
export const DEFAULT_SHORT_TERM_CAPITAL_GAINS_RATE = 0.38;
export const DEFAULT_LONG_TERM_CAPITAL_GAINS_RATE = 0.24;
